// extracted by css-extract-rspack-plugin
export default {"metricSelectInput":"VLf4B","metricLabel":"G1qpX"};